var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "extra-number" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.extraPostcode.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Postcode")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraPostcode,
                    expression: "extraPostcode"
                  }
                ],
                attrs: { type: "text", placeholder: "1200AA" },
                domProps: { value: _vm.extraPostcode },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraPostcode = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraPostcode.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Postcode")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.extraPostcode.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraPostcode,
                    expression: "extraPostcode"
                  }
                ],
                attrs: { type: "text", placeholder: "1111AA" },
                domProps: { value: _vm.extraPostcode },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraPostcode = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraPostcode.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.extraHousenumber.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Huisnummer")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraHousenumber,
                    expression: "extraHousenumber"
                  }
                ],
                attrs: { type: "text", placeholder: "1 A" },
                domProps: { value: _vm.extraHousenumber },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraHousenumber = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraHousenumber.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Huisnummer")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.extraHousenumber.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraHousenumber,
                    expression: "extraHousenumber"
                  }
                ],
                attrs: { type: "text", placeholder: "1 A" },
                domProps: { value: _vm.extraHousenumber },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraHousenumber = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraHousenumber.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.extraNumberName.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Naam")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraNumberName,
                    expression: "extraNumberName"
                  }
                ],
                attrs: { type: "text", placeholder: "Dubline" },
                domProps: { value: _vm.extraNumberName },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraNumberName = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraNumberName.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Naam")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.extraNumberName.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraNumberName,
                    expression: "extraNumberName"
                  }
                ],
                attrs: { type: "text", placeholder: "Dubline" },
                domProps: { value: _vm.extraNumberName },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraNumberName = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraNumberName.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info col" }, [
      this.$route.params.numberType == "local"
        ? _c("span", [
            _vm._v(
              "\n            Na aanvraag wordt een nummer aangemaakt in de regio van de bovenstaande postcode. Dit kan maximaal 2 werkdagen duren. De naam van het nummer ziet u in beeld als u gebeld wordt op dit nummer.\n        "
            )
          ])
        : _c("span", [
            _vm._v(
              "\n            Na aanvraag wordt een 085-nummer aangemaakt. Dit kan maximaal 2 werkdagen duren. De naam van het nummer ziet u in beeld als u gebeld wordt op dit nummer.\n        "
            )
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button row-button--bottom" }, [
      _c("div", { staticClass: "col col-100" }, [
        this.$route.params.numberType == "local"
          ? _c("input", {
              attrs: {
                type: "hidden",
                name: "extraNumberSubject",
                value: "Aanvraag lokaal nummer"
              }
            })
          : _c("input", {
              attrs: {
                type: "hidden",
                name: "extraNumberSubject",
                value: "Aanvraag 085 nummer"
              }
            }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.requestExtraNumber()
              }
            }
          },
          [_vm._v("Aanvragen")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v("Extra nummer aanvragen")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d15fc8b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d15fc8b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundles/ExtraNumberRequest.vue
// module id = null
// module chunks = 